import {Component, OnInit} from '@angular/core';
import {CurdUserprofilService} from '../../../shared/services/curd-userprofil.service';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {concatMap} from 'rxjs/operators';
import {forkJoin, of} from 'rxjs';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import * as CryptoJS from 'crypto-js';
import {ShareddataService} from '../../../shared/services/shareddata.service';

@Component({
  selector: 'app-userprofil-edit',
  templateUrl: './userprofil-edit.component.html',
  styleUrls: ['./userprofil-edit.component.scss']
})
export class UserprofilEditComponent implements OnInit {// extends CrudEdit {

  constructor(
    protected httpcrud: CurdUserprofilService, // Specific
    protected fb: UntypedFormBuilder,
    protected route: ActivatedRoute,
    protected router: Router,
    private shareddata: ShareddataService,
  ) {
    this.entityForm = new UntypedFormGroup({});
    this.model = {};
    this.fields = [];

    // this.shareddata.editprofilviewinterface$.subscribe( (data) => {this.label = data;});
  }

  entityForm: UntypedFormGroup;
  fields: FormlyFieldConfig[];
  model: {
    [propName: string]: any;
  };
  options: FormlyFormOptions = {};
  attributeGroupArray: [];

  redirecturl = '/profil';

  label = {
    save: 'save',
    cancel: 'cancel',
  };

  // labeltest = ['save', 'cancel'];

  currentLNG = this.shareddata.getCurrentlanguage();

  ngOnInit() {
    this.setModel();
  }

  onSubmit() {
    if (this.entityForm.valid) {
      const entityjson = this.model;

      if ('password' in entityjson && 'confirm_pwd' in entityjson) {
        // form has pwd, pwd confirmation and username
        if (entityjson.password === entityjson.confirm_pwd) {

          if (this.model.id) {
            const username = entityjson.username;
            const password = CryptoJS.MD5(entityjson.password).toString();

            const credential = username + '|-|||-|' + password;
            const encryptedWord = CryptoJS.enc.Utf8.parse(credential); // encryptedWord Array object
            const encryptedCredential = CryptoJS.enc.Base64.stringify(encryptedWord);

            delete entityjson.username;
            delete entityjson.password;
            delete entityjson.confirm_pwd;

            const ItemToSend = [entityjson, encryptedCredential];
            const query = this.httpcrud.updateEntity(this.model.id, ItemToSend);
            query.subscribe((allresults) => {
              this.router.navigate([this.redirecturl]);
            });
          }
        } else {
          // Form validation failed
          console.log('pwd is not valid');
        } // if/else
      } else {
        const ItemToSend = [entityjson];
        const query = this.httpcrud.updateEntity(this.model.id, ItemToSend);

        query.subscribe((allresults) => {
          this.router.navigate([this.redirecturl]);
        });
      }// if else
    } // if

  } // onSubmit

  setModel() {
    const entityid = this.route.snapshot.paramMap.get('id');
    const query = this.httpcrud.getEntity()
      .pipe(
        concatMap(data =>
          forkJoin([
            of(data),
            this.httpcrud.getFormfield(this.currentLNG.key),
            this.httpcrud.getTranslationEdition(this.currentLNG.key, this.label),
          ])
        ));
    query.subscribe((data) => {
      this.model = data[0].results;
      console.log(this.model);
      const formentity = data[1].results;
      console.log(formentity);
      this.label = data[2].results;


      Object.keys(formentity).forEach(key => {

        this.fields.push(formentity[key]);

      }); // forEach
    }); // subscribe
  } // setModel


  cancelFormSubmit() {
    this.router.navigate([this.redirecturl]);
  }
} // UserprofilEditComponent
